var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionTabBarNetWorthIconOnlyDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.03 19.086H7.957a.962.962 0 0 0-.957.957c0 .524.433.957.957.957H27.03a.962.962 0 0 0 .957-.957.962.962 0 0 0-.957-.957zM9.15 16.608a.962.962 0 0 0-.957.957c0 .524.432.957.957.957h16.687a.962.962 0 0 0 .957-.957.962.962 0 0 0-.957-.957h-.236V8.02h.236a.47.47 0 0 0 .472-.472.47.47 0 0 0-.472-.472H9.15a.47.47 0 0 0-.472.472c0 .263.21.472.472.472h.236v8.588H9.15zM23.687 8.02v8.588H20.83V8.02h2.857zm-4.771 0v8.588h-2.858V8.02h2.858zm-7.63 0h2.858v8.588h-2.857V8.02zM7.957 6.211H27.043A.962.962 0 0 0 28 5.254a.967.967 0 0 0-.642-.905L17.893.09a.918.918 0 0 0-.786 0L7.564 4.375a.946.946 0 0 0-.538 1.075c.092.446.472.76.93.76z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionTabBarNetWorthIconOnlyDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-tab-bar-net-worth-icon-only-default.ed3793c1ff1002d7773bdf0ad7b2a282.svg";